<style>

.yesno{
    display: grid;
    grid-template-columns: 2;
}

.grid-item1 {
    grid-column: 1;
}

.grid-item2 {
    grid-column: 2;
}

</style>

<div class="container feedback" on:load="{ () => eventFeedback = true}">
<Dialog show="{eventFeedback}" title="Would you come to another event hosted by XXX?" close="{false}" buttons="{ [ {text: 'Submit', callback: 'submit', disabled: false, }, {text: 'Skip', callback: 'skip', disabled: false, } ] }" on:submit="{submitFeedback}" on:skip="{ () => push('/events') }">
    <div class="yesno">
        <div class="grid-item1"><button>Yes</button></div>
        <div class="grid-item2"><button>No</button></div>
    </div>
</Dialog>
</div>

<div>
<FeedbackPrompt></FeedbackPrompt>
</div>


<script>

import {push, pop, replace, location} from 'svelte-spa-router';
import Dialog from '../components/Dialog.svelte';
import FeedbackPrompt from '../components/FeedbackPrompt.svelte'

let eventFeedback = true;

function submitFeedback() {
    push('/eventfeedback3')
}

</script>